import React from 'react';
import ModuleViewer from '../../ModuleViewer';
import axios from 'axios';
import { API } from '../../../lib/api';

const ModuleModals = ({
  handleDeleteConfirmed,
  loadingModuleAnalytics,
  moduleAnalyticsData,
  moduleToDelete,
  previewModule,
  selectedAnalyticsModule,
  setModuleToDelete,
  setPreviewLoading,
  setPreviewModule,
  setShowAnalyticsModal,
  setShowDeleteConfirm,
  setShowPreviewModal,
  showAnalyticsModal,
  showDeleteConfirm,
  showErrorNotification,
  showPreviewModal,
  showSuccessNotification
}) => {
  return (
    <>
{showPreviewModal && previewModule && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-hidden">
            <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50">
              <div className="flex items-center space-x-3">
                <span className="text-2xl">👁️</span>
                <div>
                  <h2 className="text-lg font-bold text-gray-800">Admin-Vorschau</h2>
                  <p className="text-sm text-gray-600">So sieht es der Endnutzer</p>
                </div>
              </div>
              <button
                onClick={() => {
                  setShowPreviewModal(false);
                  setPreviewModule(null);
                  setPreviewLoading(false);
                }}
                className="text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Use the exact same ModuleViewer component that end users see */}
            <div className="h-full">
              <ModuleViewer
                module={previewModule}
                isOpen={true}
                onClose={() => {
                  setShowPreviewModal(false);
                  setPreviewModule(null);
                  setPreviewLoading(false);
                }}
                onComplete={() => {
                  // Admin preview doesn't complete modules
                  console.log('Admin preview - completion blocked');
                }}
                isPreviewMode={true}
              />
            </div>
          </div>
        </div>
      )}

{showDeleteConfirm && moduleToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md">
            <div className="text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
                <svg className="h-6 w-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.864-.833-2.634 0L4.168 16.5c-.77.833.192 2.5 1.732 2.5z" />
                </svg>
              </div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Modul wirklich löschen?
              </h3>
              <p className="text-sm text-gray-500 mb-6">
                Das Modul <strong>"{moduleToDelete.title}"</strong> wird permanent gelöscht. 
                Diese Aktion kann nicht rückgängig gemacht werden.
              </p>
              <div className="flex space-x-4">
                <button
                  onClick={() => {
                    setShowDeleteConfirm(false);
                    setModuleToDelete(null);
                  }}
                  className="flex-1 px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors"
                >
                  Abbrechen
                </button>
                <button
                  onClick={handleDeleteConfirmed}
                  className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition-colors"
                >
                  Löschen
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{showAnalyticsModal && selectedAnalyticsModule && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold text-gray-800">
                📊 Analytics für "{selectedAnalyticsModule.title}"
              </h2>
              <button
                onClick={() => setShowAnalyticsModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            {/* Real Module Analytics */}
            {loadingModuleAnalytics ? (
              <div className="flex items-center justify-center py-16 text-gray-400">Daten werden geladen…</div>
            ) : (() => {
              const d = moduleAnalyticsData;
              return (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
                    <div className="bg-blue-50 p-4 rounded-xl">
                      <div className="text-2xl font-bold text-blue-600">{d ? d.users_started : '–'}</div>
                      <div className="text-sm text-blue-800">👥 Nutzer gestartet</div>
                    </div>
                    <div className="bg-green-50 p-4 rounded-xl">
                      <div className="text-2xl font-bold text-green-600">{d ? d.users_completed : '–'}</div>
                      <div className="text-sm text-green-800">✅ Abgeschlossen</div>
                    </div>
                    <div className="bg-purple-50 p-4 rounded-xl">
                      <div className="text-2xl font-bold text-purple-600">{d ? `${d.avg_time_minutes} Min` : '–'}</div>
                      <div className="text-sm text-purple-800">⏱️ Ø Bearbeitungszeit</div>
                    </div>
                    <div className="bg-orange-50 p-4 rounded-xl">
                      <div className="text-2xl font-bold text-orange-600">{d ? `${d.success_rate}%` : '–'}</div>
                      <div className="text-sm text-orange-800">📈 Erfolgsrate</div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="bg-gray-50 p-6 rounded-xl">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4">📈 Abschlüsse (letzte 8 Wochen)</h3>
                      {d && d.weekly_chart ? (
                        <div className="flex items-end gap-1 h-32">
                          {(() => {
                            const max = Math.max(...d.weekly_chart.map(w => w.count), 1);
                            return d.weekly_chart.map((w, i) => (
                              <div key={i} className="flex flex-col items-center flex-1 gap-1">
                                <span className="text-xs text-gray-500">{w.count > 0 ? w.count : ''}</span>
                                <div
                                  className="w-full rounded-t bg-indigo-500 transition-all"
                                  style={{ height: `${Math.max((w.count / max) * 88, w.count > 0 ? 4 : 0)}px` }}
                                  title={`${w.label}: ${w.count}`}
                                />
                                <span className="text-xs text-gray-400 truncate w-full text-center">{w.label}</span>
                              </div>
                            ));
                          })()}
                        </div>
                      ) : (
                        <div className="h-32 flex items-center justify-center text-gray-400 text-sm">Keine Daten vorhanden</div>
                      )}
                    </div>

                    <div className="bg-gray-50 p-6 rounded-xl">
                      <h3 className="text-lg font-semibold text-gray-900 mb-4">📋 Aktivität</h3>
                      <div className="space-y-4">
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Diese Woche</span>
                          <span className="font-bold text-gray-900">{d ? d.week_completions : '–'}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Diesen Monat</span>
                          <span className="font-bold text-gray-900">{d ? d.month_completions : '–'}</span>
                        </div>
                        <div className="flex justify-between items-center">
                          <span className="text-sm text-gray-600">Gesamt abgeschlossen</span>
                          <span className="font-bold text-gray-900">{d ? d.total_completions : '–'}</span>
                        </div>
                        <div className="pt-4 border-t border-gray-200">
                          <button
                            onClick={async () => {
                              try {
                                const res = await axios.get(`${API}/modules/${selectedAnalyticsModule.id}/export`, { responseType: 'blob' });
                                const url = URL.createObjectURL(res.data);
                                const a = document.createElement('a');
                                a.href = url;
                                a.download = `modul_${selectedAnalyticsModule.title.replace(/ /g,'_')}.csv`;
                                a.click();
                                URL.revokeObjectURL(url);
                                showSuccessNotification('CSV exportiert');
                              } catch(e) { showErrorNotification('Fehler beim Export'); }
                            }}
                            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg font-medium transition-colors"
                          >
                            📥 Als CSV exportieren
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </>
  );
};

export default ModuleModals;
